import { render, staticRenderFns } from "./introduceMember.vue?vue&type=template&id=15e63275&scoped=true"
import script from "./introduceMember.vue?vue&type=script&lang=js"
export * from "./introduceMember.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/introduce-common.scss?vue&type=style&index=0&id=15e63275&prod&lang=scss&scoped=true&external"
import style1 from "./introduceMember.vue?vue&type=style&index=1&id=15e63275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e63275",
  null
  
)

export default component.exports